import { React, useEffect, useState } from 'react';
import { useSession } from './SessionContext';
import { Button, Box, FormControl, FormLabel, Input, InputGroup, InputRightElement, Text, Card, useToast, Icon, Divider, Image, GridItem, Grid, Link, Flex } from '@chakra-ui/react';
import { useNavigate, Link as ReactRouterLink } from 'react-router-dom';
import { HTTP_STATUS_CODES } from "./GrinsCostant";
import { react_api } from './config';
//import axios from 'axios';
import { MdKey, MdPerson, MdVisibility, MdVisibilityOff } from 'react-icons/md';
//import Header from './components/Header';
import BGImage from './components/images/BgImage.jpg';
import LogoGrins from './components/images/LogoGrins.png'
import FooterLogin from './components/FooterLogin';
import { color } from 'framer-motion';
import { ExternalLinkIcon } from '@chakra-ui/icons';
import "./components/PuzzleCaptcha.css"
import PuzzleCaptcha from './components/PuzzleCaptcha';
import { useTranslation } from 'react-i18next';
import createAxiosInstance from "./interceptors/useAxiosInterceptors";
import logout from './services/authService';
import { Tooltip } from 'chart.js';

const Reindirizzamento = () => {
  const { t } = useTranslation();
  //const [data, setData] = useState(null);
  const { updateSessionData, clearSessionData } = useSession();
  const navigate = useNavigate();
  const toast = useToast();

  // EE - STATES
  const [formInputData, setFormInputData] = useState({});
  const [visibleCaptcha, setVisibleCaptcha] = useState(true);
  const [loginButtonVisible, setLoginButtonVisible] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [htmlContent, setHtmlContent] = useState(``);
  const [htmlReady, setHtmlReady] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // EE - Login Data
  const EE_Uname = "!dre@m_AMELIA-Te@m_23-25";

  //BLOCCO ORIGINALE - StateHook per Login
  // const [formInputData, setFormInputData] = useState({});
  // const [visibleCaptcha, setVisibleCaptcha] = useState(true);
  // const [loginButtonVisible, setLoginButtonVisible] = useState(false);
  // const [showPassword, setShowPassword] = useState(false);

  const toPublicArea = () => {

    sessionStorage.setItem("username", "");
    navigate('/guestApp')
    window.location.reload()
  }

  const axiosInstance = createAxiosInstance(async (axiosInstance) => {

    logout(t, clearSessionData, navigate, toast, axiosInstance)
  });

  const handleChangeFormInputData = (ev, key) => {
    setFormInputData(prevUser => ({
      ...prevUser,
      [key]: ev.target.value
    }));

    if (loginButtonVisible) {
      setVisibleCaptcha(false)
      setTimeout(() => { setVisibleCaptcha(true) }, 600)
      setLoginButtonVisible(false)
    }

  }

  const captchaOnSuccess = () => {
    setLoginButtonVisible(true)
  }

  const captchaOnFail = () => {
    setLoginButtonVisible(false)
  }

  const captchaOnRefresh = () => {
    setLoginButtonVisible(false)
  }

  const handlePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };


  const fetchDataPost = async () => {
    let toastId = 2

    if (toast.isActive(toastId)) {
      return;
    }

    setIsLoading(true);
    try {

      // Custom Request
      if (formInputData.username === EE_Uname) {

        let body = {
          username: document.getElementById('username').value.trim(),
          operID: document.getElementById('operID').value.trim()
        };

        const options = {

          headers: {
            'Content-Type': 'application/json',
          }

        }

        const urlFetch = `${react_api}/authenticateADP`;
        const response = await axiosInstance.post(urlFetch, body, options);

        const result = response.data;
        setHtmlContent(result);
        setHtmlReady(true);

      } else {

        // Standard Login 
        const payload = {
          username: document.getElementById('username').value.trim(),
          operID: document.getElementById('operID').value.trim(),
        };

        const options = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          }
        }

        const urlFetch = `${react_api}/authenticateADP`;
        const response = await axiosInstance.post(urlFetch, payload, options);
        const result = await response.data;

        if (result.status !== HTTP_STATUS_CODES.OK) {
          toast({
            title: t('toastMsg.error'),
            description: t(`messageBE.${result.message}`),
            position: "top",
            status: 'error',
            duration: 4000,
            isClosable: true
          });
        }

        if (result.status == HTTP_STATUS_CODES.OK) {
          setHtmlReady(false);
          setLoginButtonVisible(false)
          updateSessionData({ displayName: result.displayName, token: result.BearerToken, username: result.username, messaggio: result.message, role: result.role });

          if (!toast.isActive(toastId)) {

            toast({
              id: toastId,
              title: t('toastMsg.redirection.loginSuccess'),
              description: t('toastMsg.redirection.loginAs') + sessionStorage.username,
              status: 'success',
              duration: 40000,
              isClosable: true,
            });
            navigate('/'); window.location.reload();

          }

        }

        setHtmlReady(false)
        setVisibleCaptcha(false)
        setFormInputData({ username: "", password: "" })
        setTimeout(() => {
          setVisibleCaptcha(true)
          setLoginButtonVisible(false)
        }, 500)
        return (<Text>{result.status} {result.message}</Text>)
      }

    }

    catch (error) {
      toast({
        title: t('toastMsg.redirection.loginError'),
        description: String(error),
        status: 'warning',
        duration: 4000,
        isClosable: true
      });
      setHtmlReady(false);
      setVisibleCaptcha(false)
      setFormInputData({ username: "", password: "" })
      setTimeout(() => {
        setVisibleCaptcha(true)
        setLoginButtonVisible(false)
      }, 500)

    }
    finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    sessionStorage.setItem('username', '');

  }, []);

  return htmlReady ? (
    <Box h="100%">
      <Image
        src={`${react_api}/img/dt/dreamteam.JPG`}
        alt="Dream Team"
        className="card-img-top"
      />
    </Box>
  ) : (

    <Box
      width="100vw"
      height="100vh"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      overflow="hidden"
    >
      <Box
        position="absolute"
        top="0"
        left="0"
        width="100vw"
        height="100vh"
        bgImage={BGImage} // Aggiungi il percorso alla tua immagine
        backgroundSize="cover"
        backgroundPosition="center"
        filter="blur(5px)" // Imposta il livello di sfocatura
        zIndex="-1"
      />

      <Box
        flex="1"
        display="flex"
        justifyContent="center"
        alignItems="center"
      >

        <Card
          w={{ base: "90%", sm: "80%", md: "60%", lg: "40%", xl: "30%" }} // Responsive width for different breakpoints
          p={{ base: "3", md: "4" }} // Responsive padding
          shadow="lg"
          rounded="lg"
          overflow="hidden"
          boxShadow="dark-lg"
          border="1px solid"
          borderColor="rgba(11,78,90,255)"
          bgColor="#007487"
        >
          <Grid templateRows="repeat(4, auto)" rowGap={{ base: 3, md: 4 }}> {/* Use 'auto' for dynamic height */}
            {/* Username Field */}
            <GridItem>
              <FormControl isRequired>
                <FormLabel fontSize={{ base: "md", md: "lg" }} color="white" fontWeight="semibold" mb={1}>
                  <Icon as={MdPerson} /> Username
                </FormLabel>
                <Input
                  placeholder="Username"
                  name="username"
                  type="text"
                  id="username"
                  bg="white"
                  value={formInputData.username}
                  onChange={(e) => handleChangeFormInputData(e, "username")}
                  _placeholder={{ color: 'gray.500' }}
                />
              </FormControl>
            </GridItem>

            {/* Password Field */}
            <GridItem>
              <FormControl isRequired>
                <FormLabel fontSize={{ base: "md", md: "lg" }} color="white" fontWeight="semibold" mb={1}>
                  <Icon as={MdKey} /> Password
                </FormLabel>
                <InputGroup>
                  <Input
                    placeholder="Password"
                    name="operID"
                    type={showPassword ? "text" : "password"} // Cambia tipo dinamicamente
                    bg="white"
                    id="operID"
                    value={formInputData.password}
                    onChange={(e) => handleChangeFormInputData(e, "password")}
                    _placeholder={{ color: 'gray.500' }}
                  />
                  <InputRightElement width="3rem">
                    <Button h="1.75rem" size="sm" onClick={handlePasswordVisibility} bg="transparent">
                      {showPassword ? <Icon as={MdVisibilityOff} boxSize={5} /> : <Icon as={MdVisibility} boxSize={5} />}
                    </Button>
                  </InputRightElement>
                </InputGroup>
              </FormControl>
            </GridItem>

            {/* Verify Component */}
            <GridItem>
              <FormControl isRequired>
                <Box mt={1}> {/* Reduced margin-top for a tighter fit */}
                  <PuzzleCaptcha
                    visible={visibleCaptcha}
                    onSuccess={() => captchaOnSuccess()}
                    onFail={() => captchaOnFail()}
                    onRefresh={() => captchaOnRefresh()}
                  />
                </Box>
              </FormControl>
            </GridItem>

            {/* Submit Button */}
            <GridItem display="flex" justifyContent="center">

              {loginButtonVisible &&
                formInputData.username != null && formInputData.username.length > 0 &&
                formInputData.password != null && formInputData.password.length > 0 ? (
                <Button
                  isLoading={isLoading}
                  w={{ base: "70%", md: "50%" }} // Responsive button width
                  bgColor="yellowgreen"
                  color="rgba(11,78,90,255)"
                  _hover={{ bgColor: "rgba(11,78,90,255)", color: "green.300" }}
                  onClick={fetchDataPost}
                >
                  Log In
                </Button>
              ) : (

                <Text fontSize={{ base: "sm", md: "md", lg: "lg" }} color={"white"}>Verify the captcha to enter</Text>
              )}

            </GridItem>

            {/* Footer with Link */}
            <Box as="hr" borderColor="white" borderWidth="1px" />
            <GridItem>
              <Flex justifyContent="space-between" alignItems="center" mt={2} color="white">
                <Box flex="1" display="flex" justifyContent="flex-start">
                  <Button
                    size="sm"
                    bg="red.100"
                    color="rgba(11,78,90,255)"
                    // color="red.500"
                    _hover={{ bgColor: "red.500", color: "rgba(11, 78, 90, 255)" }}
                    onClick={() => navigate("/")}
                  >
                    Back
                  </Button>
                </Box>
                <Text fontSize={{ base: "xs", md: "sm", lg: "md" }} pr={2}>v.4.2.0</Text>
              </Flex>
            </GridItem>
          </Grid>
        </Card>

      </Box>

      <Box width="100%">
        <FooterLogin />
      </Box>
    </Box>
  );
};
export default Reindirizzamento;